// extracted by mini-css-extract-plugin
module.exports = {"hero":"Blog_hero__CWPPL","blogTitle":"Blog_blogTitle__zzqOF"};